<div class="flex flex-col pb-2">
  @if (isMobile()) {
    <div class="flex w-full flex-nowrap items-center gap-2">
      <div
        [hidden]="!isMobileSearchExpanded()"
        class="min-w-0 w-full"
      >
        <proffeo-ui-input
          #mobileSearch
          (debouncedValueChange)="onSearch($event)"
          (focusin)="expandMobileSearch()"
          (focusLost)="collapseMobileSearch()"
          [value]="searchPhrase()"
          [debounceMs]="300"
          [proffeoFilterCountBadge]="searchPhrase()?.length ? 1 : 0"
          [clearable]="true"
          variant="search"
          placeholder="tasks-search-text"
          class="min-w-0 w-full overflow-visible"
        />
      </div>

      @if (!isMobileSearchExpanded()) {
        @if (viewMode() === 'timeline') {
          @if (tableSettingsMenu(); as tableSettingsMenu) {
            <button
              [matMenuTriggerFor]="tableSettingsMenu"
              [attr.aria-label]="'proffeo-ui-table.choose-columns' | translate"
              [title]="'proffeo-ui-table.choose-columns' | translate"
              type="button"
              class="task-table-column-settings-trigger proffeo-ui-focus-ring"
            >
              <mat-icon fontIcon="settings" />
            </button>
          }
        } @else {
          <proffeo-task-mobile-view-settings />
        }
        <mat-button-toggle-group
          [(value)]="viewMode"
          [multiple]="false"
          [attr.aria-label]="'project-tasks.list.view.toggle-view' | translate"
          class="shrink-0"
        >
          <mat-button-toggle value="cards">
            <mat-icon
              aria-hidden="true"
              fontIcon="view_agenda"
              class="icon-sm"
            />
            <span class="sr-only">{{ 'project-tasks.list.view.toggle-list-view' | translate }}</span>
          </mat-button-toggle>
          <mat-button-toggle value="table">
            <mat-icon
              aria-hidden="true"
              fontIcon="table_rows"
              class="icon-sm"
            />
            <span class="sr-only">{{ 'task-mobile-compact-view' | translate }}</span>
          </mat-button-toggle>
          <mat-button-toggle value="timeline">
            <mat-icon
              aria-hidden="true"
              fontIcon="calendar_view_week"
              class="icon-sm"
            />
            <span>{{ 'task-schedule.view' | translate }}</span>
          </mat-button-toggle>
        </mat-button-toggle-group>

        <div class="ml-auto flex shrink-0 items-center gap-2">
          <proffeo-ui-button
            (clicked)="openAdvancedFiltersMobile()"
            [ariaLabel]="'task-filters.filters' | translate"
            [proffeoFilterCountBadge]="mobileFiltersBadgeCount()"
            [text]="'task-filters.filters'"
            [tooltip]="'task-filters.filters' | translate"
            fontIcon="filter_list"
          />

          <proffeo-ui-button
            (clicked)="filtersCleared()"
            [ariaLabel]="'project-tasks.filters.actions.clear' | translate"
            [proffeoFilterCountBadge]="activeFiltersCount()"
            [tooltip]="'project-tasks.filters.actions.clear' | translate"
            fontIcon="filter_list_off"
            class="w-12"
          />
          <proffeo-ui-button
            (clicked)="expandMobileSearch()"
            [ariaLabel]="'tasks-search-text' | translate"
            [tooltip]="'tasks-search-text' | translate"
            [proffeoFilterCountBadge]="searchPhrase()?.length ? 1 : 0"
            fontIcon="search"
          />
        </div>
      }
    </div>
  } @else {
    <div class="flex min-w-0 flex-1 flex-wrap items-center gap-2">
      <div class="flex shrink-0 items-center gap-1">
        <mat-button-toggle-group
          [(value)]="viewMode"
          [multiple]="false"
          [attr.aria-label]="'project-tasks.list.view.toggle-view' | translate"
        >
          <mat-button-toggle value="cards">
            <mat-icon
              aria-hidden="true"
              fontIcon="view_agenda"
              class="icon-sm"
            />
            <span>{{ 'project-tasks.list.view.toggle-list-view' | translate }}</span>
          </mat-button-toggle>
          <mat-button-toggle value="table">
            <mat-icon
              aria-hidden="true"
              fontIcon="table_rows"
              class="icon-sm"
            />
            <span>{{ 'project-tasks.list.view.toggle-table-view' | translate }}</span>
          </mat-button-toggle>
          <mat-button-toggle value="timeline">
            <mat-icon
              aria-hidden="true"
              fontIcon="calendar_view_week"
              class="icon-sm"
            />
            <span>{{ 'task-schedule.view' | translate }}</span>
          </mat-button-toggle>
        </mat-button-toggle-group>

        @if (tableSettingsMenu(); as tableSettingsMenu) {
          <div
            [matMenuTriggerFor]="tableSettingsMenu"
            class="inline-flex shrink-0"
          >
            <proffeo-ui-button
              [ariaLabel]="'proffeo-ui-table.choose-columns' | translate"
              [tooltip]="'proffeo-ui-table.choose-columns' | translate"
              variant="ghost"
              fontIcon="settings"
            />
          </div>
        }
      </div>

      <div class="flex min-w-0 flex-1 basis-40 items-center overflow-visible md:max-w-[28%]">
        <proffeo-ui-input
          (debouncedValueChange)="onSearch($event)"
          (focusin)="expandMobileSearch()"
          (focusLost)="collapseMobileSearch()"
          [value]="searchPhrase()"
          [debounceMs]="300"
          [proffeoFilterCountBadge]="searchPhrase()?.length ? 1 : 0"
          [clearable]="true"
          variant="search"
          placeholder="tasks-search-text"
          class="min-w-0 w-full flex-1 overflow-visible"
        />
      </div>

      <proffeo-ui-select
        [(value)]="userSelection"
        [enableEmptyValue]="true"
        [multiple]="true"
        [options]="usersOptions()"
        [proffeoFilterCountBadge]="userBadgeCount()"
        [searchable]="true"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        emptyValueLabel="task-filters.emptyValue"
        label="task-filters.users"
        class="min-w-40 flex-1 basis-40"
      />

      <proffeo-ui-select
        [(value)]="myRolesSelection"
        [multiple]="true"
        [options]="myRolesOptions()"
        [proffeoFilterCountBadge]="myRolesBadgeCount()"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        [translateLabels]="true"
        label="task-filters.myTasks"
        class="min-w-40 flex-1 basis-40"
      />

      <proffeo-ui-select
        [(value)]="taskStatusSelection"
        [multiple]="true"
        [options]="statusOptions()"
        [proffeoFilterCountBadge]="taskStatusBadgeCount()"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        label="task-filters.status"
        class="min-w-40 flex-1 basis-40"
      />
      <div
        [matMenuTriggerFor]="advancedFiltersMenu"
        [proffeoFilterCountBadge]="advancedActiveFiltersCount()"
        class="inline-flex shrink-0"
      >
        <proffeo-ui-button
          [ariaLabel]="'task-filters.filters' | translate"
          [text]="'task-filters.filters'"
          [tooltip]="'task-filters.filters' | translate"
          fontIcon="filter_list"
        />
      </div>

      <mat-menu
        #advancedFiltersMenu="matMenu"
        xPosition="before"
        class="task-advanced-filters-menu"
      >
        <div
          (click)="$event.stopPropagation()"
          class="task-advanced-filters-menu__content flex flex-col gap-3 p-4"
        >
          <proffeo-task-filters-advanced class="min-w-0 w-full" />
        </div>
      </mat-menu>

      <proffeo-ui-button
        (clicked)="filtersCleared()"
        [ariaLabel]="'project-tasks.filters.actions.clear' | translate"
        [proffeoFilterCountBadge]="activeFiltersCount()"
        [tooltip]="'project-tasks.filters.actions.clear' | translate"
        fontIcon="filter_list_off"
      />

      <proffeo-ui-button
        (clicked)="toggleImportSection()"
        [ariaLabel]="'project-tasks.import-from-template.button' | translate"
        [tooltip]="'project-tasks.import-from-template.button' | translate"
        fontIcon="upload_file"
      />

      <proffeo-ui-button
        (clicked)="exportTasks()"
        [ariaLabel]="'project-tasks.export.button-tooltip' | translate"
        [tooltip]="'project-tasks.export.button-tooltip' | translate"
        fontIcon="download"
      />

      <proffeo-ui-button
        (clicked)="startTaskCreation()"
        variant="accent"
        text="tasks-list-add-task"
        fontIcon="add"
        class="flex shrink-0 whitespace-nowrap"
      />
    </div>
  }

  @if (viewMode() === 'timeline') {
    @if (scheduleActions; as schedule) {
      <div class="flex flex-wrap items-center gap-2 pt-2">
        <mat-button-toggle-group
          (valueChange)="schedule.setPeriodMode($event)"
          [value]="schedule.isCustomWindow() ? null : schedule.periodMode()"
          [multiple]="false"
          [attr.aria-label]="'task-schedule.period' | translate"
        >
          <mat-button-toggle value="week">{{ 'task-schedule.week' | translate }}</mat-button-toggle>
          <mat-button-toggle value="month">{{ 'task-schedule.month' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
        <proffeo-ui-button
          (clicked)="schedule.movePeriod(-1)"
          [ariaLabel]="'task-schedule.previous' | translate"
          fontIcon="chevron_left"
          variant="ghost"
        />
        <div class="w-72 max-w-full shrink-0">
          <proffeo-ui-date-range-picker
            (valueChange)="schedule.setRange($event)"
            [value]="schedule.rangeControl()"
            [invalid]="schedule.invalidWindow()"
            [showClear]="false"
            label="task-schedule.period"
            startPlaceholder="project-tasks.list.column-headers.start-date"
            endPlaceholder="project-tasks.list.column-headers.end-date"
            errorMessage="task-schedule.invalid-window"
            class="w-full"
          />
        </div>
        <proffeo-ui-button
          (clicked)="schedule.movePeriod(1)"
          [ariaLabel]="'task-schedule.next' | translate"
          fontIcon="chevron_right"
          variant="ghost"
        />
      </div>
    }
  }
  @if (showImportSection()) {
    <div class="w-full pt-3">
      <proffeo-import-tasks-from-template [project]="activeProject()" />
    </div>
  }
</div>
